import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ar',
  months: [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ],
  monthsShort: [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ],
  weekdays: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  weekdaysMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  weekdaysShort: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'YYYY/MM/DD',
    LL: 'D MMMM، YYYY',
    'LL-D': 'MMMM، YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM، YYYY HH:mm',
    'LLL-Y': 'D MMMM، HH:mm',
    LLLL: 'dddd، D MMMM، YYYY HH:mm',
    'LLLL-Y': 'dddd، D MMMM HH:mm',
    l: 'YYYY/M/D',
    'l-Y': 'M/D',
    ll: 'D MMM، YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM، YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd، D MMM، YYYY h:mm A',
    'llll-Y': 'ddd، D MMM h:mm A',
    'll-Y+w': 'ddd، D MMM',
    'LT+to': 'HH:mm ([غرينتش]Z)',
    'LLL+to': 'D MMMM YYYY، HH:mm ([غرينتش]Z)',
  },
  meridiem: { am: 'ص', pm: 'م', AM: 'ص', PM: 'م' },
  past: {
    y: {
      zero: 'قبل %s سنة',
      one: 'قبل سنة واحدة',
      two: 'قبل سنتين',
      few: 'قبل %s سنوات',
      many: 'قبل %s سنة',
      other: 'قبل %s سنة',
    },
    M: {
      zero: 'قبل %s شهر',
      one: 'قبل شهر واحد',
      two: 'قبل شهرين',
      few: 'خلال %s أشهر',
      many: 'قبل %s شهرًا',
      other: 'قبل %s شهر',
    },
    w: {
      zero: 'قبل %s أسبوع',
      one: 'قبل أسبوع واحد',
      two: 'قبل أسبوعين',
      few: 'قبل %s أسابيع',
      many: 'قبل %s أسبوعًا',
      other: 'قبل %s أسبوع',
    },
    d: {
      zero: 'قبل %s يوم',
      one: 'قبل يوم واحد',
      two: 'قبل يومين',
      few: 'قبل %s أيام',
      many: 'قبل %s يومًا',
      other: 'قبل %s يوم',
    },
    h: {
      zero: 'قبل %s ساعة',
      one: 'قبل ساعة واحدة',
      two: 'قبل ساعتين',
      few: 'قبل %s ساعات',
      many: 'قبل %s ساعة',
      other: 'قبل %s ساعة',
    },
    m: {
      zero: 'قبل %s دقيقة',
      one: 'قبل دقيقة واحدة',
      two: 'قبل دقيقتين',
      few: 'قبل %s دقائق',
      many: 'قبل %s دقيقة',
      other: 'قبل %s دقيقة',
    },
    s: {
      zero: 'قبل %s ثانية',
      one: 'قبل ثانية واحدة',
      two: 'قبل ثانيتين',
      few: 'قبل %s ثوانٍ',
      many: 'قبل %s ثانية',
      other: 'قبل %s ثانية',
    },
  },
  future: {
    y: {
      zero: 'خلال %s سنة',
      one: 'خلال سنة واحدة',
      two: 'خلال سنتين',
      few: 'خلال %s سنوات',
      many: 'خلال %s سنة',
      other: 'خلال %s سنة',
    },
    M: {
      zero: 'خلال %s شهر',
      one: 'خلال شهر واحد',
      two: 'خلال شهرين',
      few: 'خلال %s أشهر',
      many: 'خلال %s شهرًا',
      other: 'خلال %s شهر',
    },
    w: {
      zero: 'خلال %s أسبوع',
      one: 'خلال أسبوع واحد',
      two: 'خلال %s أسبوعين',
      few: 'خلال %s أسابيع',
      many: 'خلال %s أسبوعًا',
      other: 'خلال %s أسبوع',
    },
    d: {
      zero: 'خلال %s يوم',
      one: 'خلال يوم واحد',
      two: 'خلال يومين',
      few: 'خلال %s أيام',
      many: 'خلال %s يومًا',
      other: 'خلال %s يوم',
    },
    h: {
      zero: 'خلال %s ساعة',
      one: 'خلال ساعة واحدة',
      two: 'خلال ساعتين',
      few: 'خلال %s ساعات',
      many: 'خلال %s ساعة',
      other: 'خلال %s ساعة',
    },
    m: {
      zero: 'خلال %s دقيقة',
      one: 'خلال دقيقة واحدة',
      two: 'خلال دقيقتين',
      few: 'خلال %s دقائق',
      many: 'خلال %s دقيقة',
      other: 'خلال %s دقيقة',
    },
    s: {
      zero: 'خلال %s ثانية',
      one: 'خلال ثانية واحدة',
      two: 'خلال ثانيتين',
      few: 'خلال %s ثوانٍ',
      many: 'خلال %s ثانية',
      other: 'خلال %s ثانية',
    },
  },
  abbr: {
    y: { zero: 'أقل من عام', one: 'عام', two: 'عامين', few: '%s أعوام', many: '%s عام', other: '%s عام' },
    M: { zero: 'أقل من شهر', one: 'شهر واحد', two: 'شهرين', few: '%s ش', many: '%s ش', other: '%s ش' },
    w: {
      zero: 'أقل من أسبوع',
      one: 'أسبوع واحد',
      two: 'أسبوعين',
      few: '%s أسابيع',
      many: '%s أسبوع',
      other: '%s أسبوع',
    },
    d: { zero: '%s ي', one: '%s ي', two: '%s ي', few: '%s أيام', many: '%s ي', other: '%s ي' },
    h: { zero: '%s س', one: '%s س', two: '%s س', few: '%s س', many: '%s س', other: '%s س' },
    m: { zero: '%s د', one: '%s د', two: '%s د', few: '%s د', many: '%s د', other: '%s د' },
    s: { zero: '%s ث', one: '%s ث', two: '%s ث', few: '%s ث', many: '%s ث', other: '%s ث' },
  },
  justNow: 'الآن',
  yesterday: 'أمس',
  today: 'اليوم',
  tomorrow: 'غدًا',
  weekStart: 0,
};
const localeName: LocaleName = 'ar';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'ص' : 'ص';
    } else {
      return isLowerCase ? 'م' : 'م';
    }
  },
};
